import(/* webpackMode: "eager", webpackExports: ["PoolChartV2"] */ "/vercel/path0/apps/web/src/ui/pool/PoolChartV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolComposition"] */ "/vercel/path0/apps/web/src/ui/pool/PoolComposition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolRewards"] */ "/vercel/path0/apps/web/src/ui/pool/PoolRewards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolStats"] */ "/vercel/path0/apps/web/src/ui/pool/PoolStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolTransactionsV2"] */ "/vercel/path0/apps/web/src/ui/pool/PoolTransactionsV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/packages/ui/dist/components/separator.js");
